import React, { useState } from 'react';
import { ModalFormLayout } from 'modules/taboola-common-frontend-modules/modals/components/ModalFormLayout/ModalFormLayout';
import { FormattedMessage } from '../../../taboola-common-frontend-modules/i18n';
import { ENTITY } from '../../config';
import TrackingSetupCodelessConversionMethodRadioGroup from '../TrackingSetupCodelessConversionMethodRadioGroup/TrackingSetupCodelessConversionMethodRadioGroup';

export const TrackingCodelessConversionSetupMethodModal = ({ onClose }) => {
    const [trackingSetupMethodType, setTrackingSetupMethodType] = useState(ENTITY.CODELESS_EVENT_TOOL);
    return (
        <ModalFormLayout
            onCancel={onClose}
            onSubmit={() => onClose(trackingSetupMethodType)}
            hasCancel={false}
            submitButtonText={
                <FormattedMessage id="app.modal.trackingSetup.button.positive" defaultMessage="Continue" />
            }
        >
            <TrackingSetupCodelessConversionMethodRadioGroup
                type={trackingSetupMethodType}
                setType={setTrackingSetupMethodType}
            />
        </ModalFormLayout>
    );
};
